var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#178DD0",
    d: "M7.059 6.497c-.202.236-.202.566-.202 1.221s0 .982.202 1.218l.086.085c.231.206.565.232 1.234.279c2.411.168 4.831.168 7.243 0c.668-.047 1.003-.073 1.234-.279l.086-.085c.201-.236.201-.562.201-1.222c0-.656 0-.986-.201-1.221a1 1 0 0 0-.086-.086c-.236-.206-.574-.231-1.247-.279A54 54 0 0 0 12 5.996c-1.371 0-2.661.068-3.608.128c-.677.052-1.012.077-1.247.283a1 1 0 0 0-.086.086zm9.951 5.992c-.051-.43-.073-.648-.274-.802c-.197-.15-.428-.128-.879-.081a19 19 0 0 0-.715.085c-.236.03-.454.077-.652.133c-.398.116-.6.172-.9.562c-.304.39-.304.703-.304 1.328v3.407c0 .412 0 .622.137.75c.133.129.352.129.789.129h1.153c.72 0 1.075 0 1.341-.232c.266-.231.296-.552.356-1.191a20 20 0 0 0-.052-4.089m-9.745-.802c-.202.154-.223.369-.275.802a19.7 19.7 0 0 0-.051 4.088c.06.643.086.96.356 1.191c.265.232.621.232 1.341.232H9.79c.437 0 .656 0 .789-.129c.137-.128.137-.338.137-.75v-3.407c0-.63 0-.943-.3-1.328c-.309-.395-.506-.45-.905-.566a5 5 0 0 0-.651-.137l-.716-.077c-.454-.043-.681-.069-.878.085z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTribe);
export default __webpack_public_path__ + "static/media/tribe.1f1ab80483209686041f12e272f210dd.svg";
export { ForwardRef as ReactComponent };